// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__39SrS","ranges":"BmiRanges_ranges__8Qldg"};